export enum PreferenceValues {
    yes = 37,
    no = 38
    } 


// WEBPACK FOOTER //
// ./src/app/common/enums/preference-value.enum.ts